import {
  fetchCspOperationStatusList
} from '@/api/mis-operation-status/csp-operation-status';
import { isFutureMonth } from '@/util/dateTimeUtils';


const getCspOperationStatusList = (context, payload) => {
  context.commit('SET_IS_CSP_LIST_LOADING', true);
  fetchCspOperationStatusList(payload).then((response) => {
    context.commit('SET_IS_CSP_LIST_LOADING', false);
    context.commit('CSP_LIST_UPDATED', response);
  }).catch((error) => {
    // eslint-disable-next-line
    context.commit('SET_IS_CSP_LIST_LOADING', false);
    console.error(error);
  });
};

export default {
  getCspOperationStatusList
};



// WEBPACK FOOTER //
// ./src/store/modules/mis-operation-status/csp-operation-status/actions.js